import { TViewMode } from '../../ProjectsOnMap/ProjectsOnMap';
import { INewBuilding } from '../../../types/newBuldings';
import { IOffice } from '../../../types/offices';

interface IPrepareTrackingEventArguments {
  mode: TViewMode;
  newbuildings: INewBuilding[];
  offices: IOffice[];
  geoId: string;
}

export function prepareTrackingEvent({ mode, newbuildings, offices, geoId }: IPrepareTrackingEventArguments) {
  const event: { id: number; position: number } = { id: -1, position: 0 };

  if (mode === 'newBuildings') {
    const currentId = Number(geoId);
    const currentNewbuildingIndex = newbuildings.findIndex(newbuilding => newbuilding.id === currentId);

    event.id = currentId;
    event.position = currentNewbuildingIndex + 1;

    newbuildings.forEach((item, index) => {
      if (item.id === currentId) {
        event.id = currentId;
        event.position = index + 1;
      }
    }, {});
  }

  if (mode === 'offices') {
    offices.forEach((item, index) => {
      if (
        item.coordinates?.lat &&
        item.coordinates?.lng &&
        `${item.coordinates.lat}${item.coordinates.lng}` === geoId
      ) {
        event.id = item.newbuildingId || -1;
        event.position = index + 1;
      }
    }, {});
  }

  return event;
}
